import { getComponentCategoryData } from "@/util/qualityUtil/componentCategory"; // 零部件列表
import { severityList, severityListKD } from "@/util/qualityUtil/severityLevels"; // 严重程度
import { getCheckPart } from "@/util/qualityUtil/checkPart"; // 获取疑似/祸首件名称
export default {
  data() {
    return {
      componentCategoryList:[], // 零部件类别
      componentCategoryName: "", // 零部件类别map
      severityData: [], //严重程度
      severityDataKD:[],
    }
  },
  methods: {
    getTypeList() {
      // 零部件列表
      getComponentCategoryData(this);
      // 严重程度
      this.severityData = severityList;
      this.severityDataKD = severityListKD;
    },
    // 获取疑似/祸首件名称
    getCheckPartInfo() {
      getCheckPart(this);
    },
    // 获取反馈单信息
    getFeedbackDetail() {
      const submitData = JSON.parse(JSON.stringify(this.form));
      let recordObj = {
        engineRecordList: this.form.engineRecordList,
        transmissionRecordList: this.form.transmissionRecordList,
      };
      submitData.maintenanceRecord = JSON.stringify(recordObj);
      submitData.maintenanceRecordInfo = recordObj;
      // 是否重点问题
      this.form.importantType == 0 && (submitData.importantDescribe = "");
      // 是否有维修措施
      this.form.serviceMeasure == 0 && (submitData.marketService = "");
      // 图片和视频 选择否 置空附件备注信息
      this.form.faultVideo == 0 && (this.form.faultVideoFiles = "");
      this.form.faultCode == 0 && (submitData.faultCodeRemark = this.form.faultCodeFiles = "");
      this.form.otherInstructions == 0 && (submitData.otherRemark = this.form.otherFiles = "");
      // 3. 统一处理附件转字符串（提取公共方法）
      const stringifyIfNotEmpty = (arr) => (Array.isArray(arr) && arr.length) ? JSON.stringify(arr) : "";
      // 附件信息转字符串
      submitData.faultCommonFiles = stringifyIfNotEmpty(this.form.faultCommonFiles);
      submitData.faultVideoFiles = stringifyIfNotEmpty(this.form.faultVideoFiles);
      submitData.faultCodeFiles = stringifyIfNotEmpty(this.form.faultCodeFiles);
      submitData.otherFiles = stringifyIfNotEmpty(this.form.otherFiles);
      return submitData
    }
  },
}
